import { render, staticRenderFns } from "./viewItemList.vue?vue&type=template&id=87919e18&scoped=true"
import script from "./viewItemList.vue?vue&type=script&lang=js"
export * from "./viewItemList.vue?vue&type=script&lang=js"
import style0 from "./viewItemList.vue?vue&type=style&index=0&id=87919e18&prod&scoped=true&lang=css"
import style1 from "./viewItemList.vue?vue&type=style&index=1&id=87919e18&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87919e18",
  null
  
)

export default component.exports